var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.config_estate
    ? _c(
        "div",
        {
          staticClass: "estate-images",
          class: "estate-images-v" + _vm.config_estate.media_template
        },
        [
          _vm.$root.is_mobile
            ? _c(
                "div",
                { staticClass: "mobile-carousel" },
                [
                  _c("estate-actions", { attrs: { estate: _vm.estate } }),
                  _vm._v(" "),
                  _c(
                    "my-carousel",
                    { attrs: { "per-page": 1 } },
                    _vm._l(_vm.estate.media.images, function(image) {
                      return _c(
                        "slide",
                        { key: image.id },
                        [
                          _c("lazy-image", {
                            attrs: { image: image.url.gallery_media }
                          })
                        ],
                        1
                      )
                    }),
                    1
                  ),
                  _vm._v(" "),
                  _c("media-gallery-opener", { attrs: { estate: _vm.estate } })
                ],
                1
              )
            : _vm.config_estate.media_template == 2
            ? _c("div", { staticClass: "desktop-mosaic p-03" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-8 cursor-pointer pr-0",
                      on: {
                        click: function($event) {
                          return _vm.openMediaGallery(0)
                        }
                      }
                    },
                    [
                      _c("lazy-image", {
                        attrs: {
                          image: _vm.estate.media.images[0]
                            ? _vm.estate.media.images[0].url.detail
                            : "",
                          "additional-class": "main-image",
                          width: "810",
                          height: "655"
                        }
                      }),
                      _vm._v(" "),
                      _c("media-gallery-opener", {
                        attrs: {
                          estate: _vm.estate,
                          "container-class": "media-buttons"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-4" }, [
                    _c(
                      "div",
                      { staticClass: "row" },
                      [
                        _vm.estate.media.images.length > 4
                          ? _c(
                              "div",
                              {
                                staticClass: "image_count",
                                on: {
                                  click: function($event) {
                                    return _vm.openMediaGallery(3)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: { src: "/img/icons/ico_photo.svg" }
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(
                                    "+" +
                                      _vm._s(_vm.estate.media.images.length - 4)
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.range(1, 4), function(i) {
                          return _c(
                            "div",
                            {
                              key: i,
                              staticClass: "col-12 cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.openMediaGallery(i)
                                }
                              }
                            },
                            [
                              _c("lazy-image", {
                                attrs: {
                                  image: _vm.estate.media.images[i]
                                    ? _vm.estate.media.images[i].url
                                        .gallery_media
                                    : "",
                                  width: "288",
                                  height: "216"
                                }
                              })
                            ],
                            1
                          )
                        })
                      ],
                      2
                    )
                  ])
                ])
              ])
            : _vm.config_estate.media_template == 1
            ? _c("div", { staticClass: "desktop-mosaic" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-7 cursor-pointer",
                      on: {
                        click: function($event) {
                          return _vm.openMediaGallery(0)
                        }
                      }
                    },
                    [
                      _c("lazy-image", {
                        attrs: {
                          image: _vm.estate.media.images[0]
                            ? _vm.estate.media.images[0].url.detail
                            : "",
                          "additional-class": "main-image",
                          width: "810",
                          height: "500"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col-5" },
                    [
                      _c(
                        "div",
                        { staticClass: "row" },
                        _vm._l(_vm.range(1, 5), function(i) {
                          return _c(
                            "div",
                            {
                              key: i,
                              staticClass: "col-6 cursor-pointer",
                              on: {
                                click: function($event) {
                                  return _vm.openMediaGallery(i)
                                }
                              }
                            },
                            [
                              _c("lazy-image", {
                                attrs: {
                                  image: _vm.estate.media.images[i]
                                    ? _vm.estate.media.images[i].url
                                        .gallery_media
                                    : "",
                                  width: "288",
                                  height: "216"
                                }
                              })
                            ],
                            1
                          )
                        }),
                        0
                      ),
                      _vm._v(" "),
                      _c("media-gallery-opener", {
                        attrs: {
                          estate: _vm.estate,
                          "container-class": "media-buttons"
                        }
                      })
                    ],
                    1
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("modal-media-gallery")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }